import * as actionType from "../constants";
import * as commonData from "../Common";
import { fetchAllRows } from "./create-attribute";

export const renameAttribute = (inputs) => async (dispatch) => {
  const apiurl = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${apiurl}attribute/update`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      let hidedata = !rdata.data?.[0].show_on_column ? rdata.data?.[0] : "";
      const newcols = { ...rdata.data[0], hide: !rdata.data[0].show_on_column };
      dispatch({
        type: actionType.ATTRIBUTE_RENAME_DONE,
        payload: {
          data: newcols || [],
          actionFields: inputs?.attribute_properties,
          message: rdata.message,
          code: rdata.code,
          status: rdata.status,
          board: true,
          hidden: hidedata,
        },
      });
      // dispatch(
      //   fetchAllRows(
      //     {
      //       app_token: inputs.app_token,
      //       key: inputs.attribute_set_key,
      //     },
      //     { update: 1 }
      //   )
      // );
      return rdata;
    } else {
      dispatch({
        type: actionType.ATTRIBUTE_RENAME_DONE,
        payload: {
          data: [],
          actionFields: inputs?.attribute_properties,
          message: rdata.message,
          code: rdata.code,
          status: rdata.status,
          board: true,
          hidden: hidedata,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};
